import { render } from "./BatchProcessingManager.vue?vue&type=template&id=55890896&scoped=true"
import script from "./BatchProcessingManager.vue?vue&type=script&lang=js"
export * from "./BatchProcessingManager.vue?vue&type=script&lang=js"

import "./BatchProcessingManager.vue?vue&type=style&index=0&id=55890896&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55890896"]])

export default __exports__